export enum Permission {
  EnvironmentSelector = 'environmentSelector',
  ViewAllTracks = 'viewAllTracks',
  ViewAllDynascores = 'viewAllDynascores',
  PromoteDemote = 'promoteDemote',
  SyncFacetData = 'syncFacetData',
  ManageRenderQueues = 'manageRenderQueues',
}
